export default __webpack_public_path__ + "static/06_V1@2x-ac0e306bd271652746b10eee214275a2.png";